var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z","fill":"#02D2A0","key":0}),React.createElement("path",{"d":"M9.71585 10.0938L21.1876 25.4322L9.64355 37.9032H12.2419L22.3489 26.9844L30.5147 37.9032H39.3562L27.2388 21.7021L37.984 10.0938H35.3857L26.078 20.1494L18.5574 10.0938H9.71585ZM13.5368 12.0074H17.5985L35.5348 35.9895H31.4731L13.5368 12.0074Z","fill":"#002432","key":1})]);
}

Twitter.defaultProps = {"width":"49","height":"48","viewBox":"0 0 49 48","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
